import * as PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import Modal from '../Modal';

const NewPermanentLink = ({ onGenerateNew, onClose }) => {
  const { t } = useTranslation('components');

  return (
    <Modal showCloseButton onClickCloseButton={onClose} title={t(`NewPermanentLink.title`)}>
      <div className="mb-6">{t(`NewPermanentLink.text`, { allowHtml: true })}</div>
      <Button onClick={onGenerateNew} className="w-full mb-8">
        {t(`NewPermanentLink.button`)}
      </Button>
      <button
        type="button"
        onClick={onClose}
        className="focus:outline-none text-slate-500 hover:underline flex justify-center w-full"
      >
        {t('NewPermanentLink.cancel')}
      </button>
    </Modal>
  );
};

NewPermanentLink.defaultProps = {
  onGenerateNew: () => {},
  onClose: () => {},
};

NewPermanentLink.propTypes = {
  onGenerateNew: PropTypes.func,
  onClose: PropTypes.func,
};

export default NewPermanentLink;
